/* eslint-disable @typescript-eslint/naming-convention */

/**
 * @internal This is an experimental interface and will be changed post design review.
 * {@docCategory ISpacing}
 */
export interface ISpacing {
  s2: string;
  s1: string;
  m: string;
  l1: string;
  l2: string;
}
